import styles from './index.module.css';
import GroupImage from '../../../assets/images/landingPage/about_back_img.png';

const AboutUs = () => {
    return (
        <div className={`main-container ${styles.aboutUs}`}>
            <div className={`container-content`}>
                <div className={styles.aboutUsContainer}>
                    <div className={styles.aboutUsCard}>
                        <div className={styles.cardTitle}>
                            Our Story <br />
                            <span className={styles.companyTitle}>Ardillalabs</span>
                        </div>
                        <p className={styles.cardText}>
                            At Ardillalabs, innovation is more than a buzzword — it’s part of our story. We started with a simple idea: to help businesses unlock their potential through technology that truly makes a difference. Today, we design and develop websites, scalable web systems, and mobile apps that empower organizations to grow and thrive. Alongside core development, we also bring the future closer with advanced solutions in Artificial Intelligence, Natural Language Processing, and Machine Learning — from smart chatbots to predictive analytics. Every project we take on is built with passion, creativity, and a commitment to results, because we believe in creating not just software, but lasting partnerships.
                        </p>
                    </div>
                    <img src={GroupImage} alt='group' className={styles.groupImg} />
                </div>
            </div>
        </div>
    )
}

export default AboutUs;